import { CSSProperties, useMemo } from 'react';

export const useFavoriteToggleStyles = (
  height: number
): { iconHeight: number; toggleStyle: CSSProperties } => {
  // The zola-ui favorites SVG have a padding baked in, which we need to compensate for.
  const values = useMemo(() => {
    const padding = Math.round((10 / 24) * height);

    return {
      iconHeight: height + 2 * padding,
      toggleStyle: { margin: -padding },
    };
  }, [height]);

  return values;
};
